import { FC } from 'react'
import { Button, HStack, IconButton, VStack } from '@chakra-ui/react'
import {
  IPadding,
  ISectionTestAddWords,
  ISectionTestLinkByMeaning,
  ITestContent,
  ITestMatching
} from 'shared/types'
import get from 'lodash/get'
import PaddingSelect from 'components/PaddingSelect'
import HighlightCorrectAnswer from 'components/contentSettingsCard/HighlightCorrectAnswer'
import SimpleInput from 'shared/components/SimpleInput'
import { getTestTitle } from 'shared/utils/tests'
import _ from 'lodash'
import { ReactComponent as IconDelete } from 'shared/assets/bsTrash.svg'
import Label from 'shared/components/Label'
import { generateId } from 'controllers/db'

// import EditTestAddWords from 'components/contentSettingsCard/EditTestAddWords'

type Props = {
  s: ISectionTestLinkByMeaning
  onChange: (s: ISectionTestLinkByMeaning) => void
}

const EditSectionTestLinkByMeaning: FC<Props> = ({ s, onChange }) => {
  const addMatch = () => {
    const newMathching = [
      ...(s.test?.matching || []),
      { word1: '', word2: '', id: generateId() }
    ]
    onChange({
      ...s,
      test: { ...(s.test || {}), matching: newMathching }
    })
  }

  const renderPadding = () => {
    return (
      <PaddingSelect
        value={s.paddingTop}
        onChange={(v: IPadding) => onChange({ ...s, paddingTop: v })}
      />
    )
  }

  const renderHighlightCorrectAnswer = () => {
    const v = get(s, 'test.highlightCorrectAnswer', false)
    return (
      <HighlightCorrectAnswer
        value={v}
        onChange={(v: boolean) =>
          onChange({
            ...s,
            test: { ...(s.test || {}), highlightCorrectAnswer: v }
          })
        }
      />
    )
  }

  const renderTitle = () => {
    return (
      <SimpleInput
        value={s.test?.title || getTestTitle(s.type)}
        onChange={(v: string) =>
          onChange({ ...s, test: { ...(s.test || {}), title: v } })
        }
        label='Вопрос'
      />
    )
  }

  const onDelete = (i: number) => {
    const newMatching = [...(s.test?.matching || [])]
    newMatching.splice(i, 1)
    onChange({ ...s, test: { ...(s.test || {}), matching: newMatching } })
  }

  const renderMatchingRow = (m: ITestMatching, i: number) => {
    return (
      <HStack w='full' key={i}>
        <SimpleInput
          value={m.word1}
          onChange={(value: string) => {
            const newMatching = _.map(s.test?.matching, (v, k) => {
              if (k === i) {
                return {
                  ...m,
                  word1: value
                }
              } else {
                return v
              }
            })
            onChange({
              ...s,
              test: { ...(s.test || {}), matching: newMatching }
            })
          }}
        />
        <SimpleInput
          value={m.word2}
          onChange={(value: string) => {
            const newMatching = _.map(s.test?.matching, (v, k) => {
              if (k === i) {
                return {
                  ...m,
                  word2: value
                }
              } else {
                return v
              }
            })
            onChange({
              ...s,
              test: { ...(s.test || {}), matching: newMatching }
            })
          }}
        />
        <IconButton
          size='sm'
          colorScheme='red'
          aria-label='delete'
          variant={'ghost'}
          icon={<IconDelete width={16} height={16} />}
          onClick={() => onDelete(i)}
        />
      </HStack>
    )
  }

  const renderButton = () => {
    return (
      <Button variant={'primary'} onClick={addMatch} mt={4}>
        Добавить строку
      </Button>
    )
  }

  const renderEditContent = () => {
    return (
      <VStack w='full' align={'start'}>
        <Label>Задание</Label>
        {_.map(s.test?.matching, (m, i) => {
          return renderMatchingRow(m, i)
        })}
        {renderButton()}
      </VStack>
    )
  }

  return (
    <VStack w='full' spacing={6}>
      {renderPadding()}
      {renderTitle()}
      {renderHighlightCorrectAnswer()}
      {renderEditContent()}
    </VStack>
  )
}

export default EditSectionTestLinkByMeaning
